"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../controls/services");
var UsernamePipe = /** @class */ (function () {
    function UsernamePipe(userService) {
        this.userService = userService;
    }
    UsernamePipe.prototype.transform = function (id) {
        return this.userService.getById(id).map(function (user) {
            return (user && user.properties && user.properties.FIRSTNAME + ' ' + user.properties.LASTNAME) || '';
        });
    };
    UsernamePipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'username',
                    pure: true
                },] },
    ];
    /** @nocollapse */
    UsernamePipe.ctorParameters = function () { return [
        { type: services_1.UserService, },
    ]; };
    return UsernamePipe;
}());
exports.UsernamePipe = UsernamePipe;
//# sourceMappingURL=username.pipe.js.map